import React, { Fragment } from 'react'
import styles from './StatisticsTable.module.sass'
import { StatisticsRow } from '../../../../responses/statistics'
import { ColumnConfiguration, OpenConfiguration } from './configuration'
import { Ord } from 'fp-ts/Ord'
import * as A from 'fp-ts/Array'
import { pipe } from 'fp-ts/function'
import Button from '../../../controls/Button/Button'
import ChevronDownIcon from 'files/chevron/down.svg'
import clsx from 'clsx'
import { Classes } from '../../../../styles'

interface Props<T> {
    data: StatisticsRow<T>,
    open?: OpenConfiguration,
    config: ColumnConfiguration<T>[],
    ord: Ord<StatisticsRow<T>>,
    level: number,
    onToggle: (open: OpenConfiguration) => void,
}

const StatisticsTableRow = <T extends unknown>(props: Props<T>): JSX.Element => {
    const shift = props.level * 20 + 40
    return <Fragment>
        <tr>
            <td className={styles.name} style={{paddingLeft: shift}}>
                {
                    props.data.rows && <div className={styles.toggle} style={{left: shift - 35}}>
                        <Button onClick={() => props.onToggle({open: !props.open?.open})}>
                            <ChevronDownIcon className={clsx({[Classes.flip]: props.open?.open})}/>
                        </Button>
                    </div>
                }
                {props.data.name}
            </td>
            {
                props.config.map(column => <td
                    key={`${column.group}-${column.name}`}
                >
                    {column.render(props.data)}
                </td>)
            }
        </tr>
        {
            props.open?.open && pipe(
                props.data.rows ?? [],
                A.sort(props.ord),
                A.mapWithIndex((index, row) => <StatisticsTableRow
                    key={index}
                    data={row}
                    open={props.open?.children?.[index]}
                    config={props.config}
                    ord={props.ord}
                    level={props.level + 1}
                    onToggle={open => props.onToggle({
                        open: !!props.open?.open,
                        children: {
                            ...props.open?.children,
                            [index]: open,
                        }
                    })}
                />)
            )
        }
    </Fragment>
}

export default StatisticsTableRow